import { render, staticRenderFns } from "./ChatModeration.vue?vue&type=template&id=4b8535c0&"
import script from "./ChatModeration.vue?vue&type=script&lang=js&"
export * from "./ChatModeration.vue?vue&type=script&lang=js&"
import style0 from "./ChatModeration.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChatModeration.vue"
export default component.exports